import React from "react";
import SimpleTable from "../tables/SimpleTable";
import {WellSlot} from "../../types/WellSlot";
import {AccessionRecord, AccessionRecordType} from "./AccessionRecord";
import {getNextWellSlot, parseDate} from "../../util/FormatUtil";
import {WellMapData} from "./WellPlateReport";
import Batch from "../../types/Batch";
import { sweetalert } from "../../App";

// NOTE - The well map plate was removed from the navigation menu since the functionality exists elsewhere now
interface WellPlateMapProps {
    printRef?
    batchNum?:string
    plateData: WellMapData[]
    slotMap: WellSlot[]
    batch?:Batch
    starterWellSlot?:string
    onCellChange?
    clearWellSlot?
    hasResult?
    isPerio?:boolean
    isComprehensive?:boolean
}
interface WellPlateMapState {
    processedDate?:string
    facilitiesCount: {name, count}[]
    twelveArray: number[]
    perioNumberLabelArray: string[]
    perioNumberArray: number[]
    comprehensiveNumberLabelArray: string[]
    comprehensiveNumberArray: number[]
    letterArr: string[]
    selectedWellSlot: string
}
export class WellPlateMap extends React.Component<WellPlateMapProps, WellPlateMapState>{

    constructor(props) {
        super(props);
        this.state = {
            facilitiesCount: [],
            letterArr: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
            twelveArray: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            perioNumberArray: [1, 2, 3, 4, 5, 6],
            perioNumberLabelArray: ['1/7', '2/8', '3/9', '4/10', '5/11', '6/12'],
            comprehensiveNumberArray: [1, 2, 3],
            comprehensiveNumberLabelArray: ['1/4/7/10', '2/5/8/11', '3/6/9/12'],
            selectedWellSlot: '',
        }
    }

    componentWillReceiveProps(nextProps: Readonly<WellPlateMapProps>, nextContext: any) {
        if(nextProps.plateData.length > 0){
            this.getFacilityCounts(nextProps.plateData);
        }
        if(nextProps.starterWellSlot){
            this.setState({selectedWellSlot: nextProps.starterWellSlot})
        }
    }

    getFacilityCounts(data) {
        let facilityCountArr:{name, count}[] = [];
        for(const samp of data){
            let match = facilityCountArr.find(f => f.name === samp.FacilityAbbreviation);
            if(!match){
                facilityCountArr.push({name: samp.FacilityAbbreviation, count: 1})
            } else {
                match.count++;
            }
        }
        this.setState({
            facilitiesCount: facilityCountArr,
            processedDate: parseDate(data[0].ProcessedDate),
        })
    }

    getTableRow = (letter: string) => {
        let numberArray = this.props.isComprehensive ? this.state.comprehensiveNumberArray:  this.props.isPerio ? this.state.perioNumberArray : this.state.twelveArray;
        return (<tr>
            <td className="col px-2 text-center font-weight-bold"
                style={{paddingTop: '2em', backgroundColor: 'pink', width: '7.7%'}}>{letter}</td>
            {numberArray.map((num, index) => {

                    let slot = this.props.slotMap.find(s => s.WellSlot === (letter + num))
                    let r = this.props.plateData.find(r => r.WellSlot === (letter + num));
                    let ws = (letter + num).toString();

                    r = r ? r : {
                        SpecimenID: null,
                        FacilityAbbreviation: null,
                        InternalSpecimenID: null,
                        RerunCount: 0,
                        WellSlot: ws,
                        ProcessedDate: null,
                        BatchNum: ""
                    }
                    if (slot && slot.IsBlocked) {

                        let color = slot.BackgroundClass;
                        return (
                            <td className={"col p-0 text-center font-weight-bold " + color}
                                style={{width: '7.7%', height: '6em'}}>{slot.BlockedText}
                            </td>
                        )
                    } else {
                        if(this.props.hasResult){
                            return (
                                <td className="col p-0" style={{width: '7.7%', height: '6em'}}>
                                    <AccessionRecord rowData={r && r as AccessionRecordType} />
                                </td>
                            )
                        }
                        else{
                            return (
                                <td className="col p-0"
                                    style={{width: '7.7%', height: '6em'}}
                                    onClick={() => {
                                        let clickedWellSlot = r.WellSlot
                                        if(r.SpecimenID && !this.props.hasResult){
                                            sweetalert.fire({
                                                icon: 'warning',
                                                title: 'Well Slot already in use',
                                                text: 'Do you want to clear it?',
                                                showCloseButton: false,
                                                showDenyButton: true,
                                                showCancelButton: false,
                                                showConfirmButton: true,
                                                confirmButtonText: 'Yes, clear',
                                                denyButtonText: `Go Back`,
                                            }).then((result) => {
                                                if (result.isConfirmed){
                                                    this.props.clearWellSlot(r)
                                                }
                                                else if(result.isDenied) {
                                                    this.props.clearWellSlot(false)
                                                }
                                            })
                                        }

                                        this.setState({selectedWellSlot: clickedWellSlot})
                                        this.props.onCellChange(clickedWellSlot)
                                    }}
                                >
                                    <div style={this.state.selectedWellSlot === r.WellSlot ? {width: '100%', height: '100%', border: '5px solid yellow'} : {}}>
                                        <AccessionRecord rowData={r && r as AccessionRecordType} />
                                    </div>
                                </td>
                            )
                        }
                        
                    }
                }
            )}
        </tr>)
    }

    render() {
        // console.log('WellPlateMap props', this.props)
        // console.log('WellPlateMap state', this.state)
        return(
            <div>
                <div className={"container-fluid"}>
                    <div className="row mt-5" style={{height: '50px'}}>
                        <div className="col">
                            <img src={'https://storage.googleapis.com/streamline-bucket/FullLogo.png'} style={{height: '100px'}}
                                 alt={"logo"}/>
                        </div>
                        <div className="col">
                            <div style={{fontWeight: 'bold'}}>Batch #: {this.props.batchNum ? this.props.batchNum : ""} </div>
                        </div>
                        <div className="col">
                            <div style={{fontWeight: 'bold'}}>Processed Date: {this.state.processedDate ? this.state.processedDate : ""}</div>
                        </div>
                    </div>

                    <div className="row mt-5" style={{height: '20px'}}>
                        <div className="offset-2 col-5">
                            <div style={{fontWeight: 'bold', fontStyle: 'italic', fontSize: '0.7em'}}>Aliquoting
                                Personnel: _____________________________________________________
                            </div>
                        </div>
                        <div className="col-5">
                            <div style={{fontWeight: 'bold', fontStyle: 'italic', fontSize: '0.7em'}}>Extraction
                                Personnel: _____________________________________________________
                            </div>
                        </div>
                    </div>
                    {/*testing table*/}
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className={"table-responsive-sm"}>
                                <table className="printable-table table-print table-sm table-bordered">
                                    <thead>
                                    <tr>
                                        <th className={'text-center p-0'}
                                            style={{width: '15em', height: '0.5em', backgroundColor: 'pink'}}/>
                                        {
                                            this.props.isComprehensive ? 
                                                this.state.comprehensiveNumberLabelArray.map(m => (
                                                    <th className={'text-center'}
                                                        style={{
                                                            width: '15em',
                                                            height: '0.5em',
                                                            backgroundColor: 'pink'
                                                        }}>{m}</th>))
                                            : 
                                            this.props.isPerio ? 
                                                this.state.perioNumberLabelArray.map(m => (
                                                    <th className={'text-center'}
                                                        style={{
                                                            width: '15em',
                                                            height: '0.5em',
                                                            backgroundColor: 'pink'
                                                        }}>{m}</th>))
                                            : 
                                            this.state.twelveArray.map(m => (
                                                <th className={'text-center'}
                                                    style={{
                                                        width: '15em',
                                                        height: '0.5em',
                                                        backgroundColor: 'pink'
                                                    }}>{m}</th>))
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.letterArr.map(l => {
                                        return this.getTableRow(l)
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 NotesSection">
                        <div className="col-8 mb-3">
                            <p className="test">Notes: {this.props.batch ? this.props.batch.Notes : ""}</p>
                            <SimpleTable table_style={"text-center"} columns={[
                                {label:"Facility", key:"name"},
                                {label:"Specimen Count", key:"count"}
                            ]} appendRows={(
                                <tr>
                                    <td><b>Total</b></td>
                                    <td>{this.props.plateData.length}</td>
                                </tr>)} table_data={this.state.facilitiesCount}/>
                        </div>
                    </div>
                </div>
            </div>)
    }
}